// extracted by mini-css-extract-plugin
module.exports = {"triangle-down-right":"styles-module__triangle-down-right___xYzAT","shareContainer":"styles-module__shareContainer___3q5nA"};